// Third-party
import React from 'react';
import classNames from 'classnames';
import { VALUE_SPACE } from 'keycode-js';

interface Props {
  label: string | React.ReactNode;
  onChange: (checked: boolean) => void;
  selected: boolean;
  disabled: boolean;
  dark?: boolean;
  className?: string;
}

const Radio = ({ label, className, onChange = () => {}, selected = false, disabled = false, dark, ...props }: Props) => {
  const onClick = () => {
    if (disabled) {
      return;
    }
    onChange(!selected);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // This is not how accessible radio buttons should be built - arrow keys should be used to navigate
    // through the options, but this has proven to be a huge challenge when dealing with the current
    // context in which our radio buttons are used. This at least provides a keyboard-friendly
    // experience, but please refer to this documentation when we invest in true accessibility:
    // https://www.w3.org/WAI/ARIA/apg/example-index/radio/radio-rating.html
    if (e.key === VALUE_SPACE) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <div
      onClick={onClick}
      className={classNames(className, 'radio', { disabled, dark })}
      aria-checked={selected}
      role="radio"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className={classNames('radio-button', { selected })}>
        <div className="inner-button" />
      </div>
      <label>{label}</label>
    </div>
  );
};

export default Radio;
